import React, { useLayoutEffect, forwardRef } from 'react';
import { useRelativeDate } from '~/react-hooks/use-date';

import ResourceTagBar from '~/App/Modules/Tags/Components/ResourceTagBar';
import { TaggableResourceType } from '~/types/models/tags';
import { useTaggableResourcePage } from '../hooks/use-taggable-resource-page';
import { UserWebAsset } from '~/types/models';
import WebAssetActionLinks from './WebAssetActionLinks';
import { WebAssetEmbed } from './WebAssetEmbed';

export interface WebAssetThumbnailProps {
  asset: UserWebAsset;
  resourceType?: TaggableResourceType;
  onTagUpdated?: () => void;
  onAssetLoad?: () => void;
  hideTagBar?: boolean;
  hideContactTagging?: boolean;
}

const WebAssetThumbnail = forwardRef<HTMLDivElement, WebAssetThumbnailProps>(
  (props, detailsContainerRef) => {
    const {
      asset,
      resourceType = TaggableResourceType.UserWebAsset,
      onTagUpdated,
      onAssetLoad,
      hideTagBar = false,
    } = props;
    const taggableResourcePage = useTaggableResourcePage();
    const createdAgo = useRelativeDate(asset.created_at);

    const { type, url, content } = asset;

    useLayoutEffect(() => {
      onAssetLoad?.();
    }, []);

    return (
      <div className='!w-full flex flex-col gap-y-2.5 mx-auto'>
        <WebAssetEmbed
          url={url}
          type={type}
          content={content}
          onLoad={onAssetLoad}
        />
        <div ref={detailsContainerRef}>
          <div className='flex justify-between align-items w-full px-1'>
            <div className='inline-flex items-center flex-wrap w-full'>
              {createdAgo}
            </div>
            <WebAssetActionLinks asset={asset} />
          </div>
          {!hideTagBar && (
            <ResourceTagBar
              emptyText='Add a tag'
              onTagResourceSuccess={onTagUpdated}
              onUnTagResourceSuccess={onTagUpdated}
              resource={asset}
              resourceType={resourceType}
              sourcePage={taggableResourcePage}
            />
          )}
        </div>
      </div>
    );
  }
);

export default WebAssetThumbnail;
